import AntdModal, { ModalProps as AntdModaLProps } from 'antd/lib/modal/Modal';

export interface ModalProps extends AntdModaLProps {
  children: React.ReactNode;
}

export const Modal = ({ children, ...rest }: ModalProps) => {
  return <AntdModal {...rest}>{children}</AntdModal>;
};
